import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getAllYoutubeVisuals = createAsyncThunk(
  "admin/allYoutubeVisuals",
  async ({page, limit,}, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/youtube-visuals/all?page=${page}&limit=${limit}`, {
        headers: authHeader(),
      });
      return response; 
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleYoutubeVisuals = createAsyncThunk(
  "admin/singleYoutubeVisuals",
  async (YoutubeVisualsId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/youtube-visuals/${YoutubeVisualsId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const addYoutubeVisuals = createAsyncThunk(
  "admin/addYoutubeVisuals",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/youtube-visuals/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const editYoutubeVisuals = createAsyncThunk(
  "admin/editYoutubeVisuals",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/youtube-visuals/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteYoutubeVisuals = createAsyncThunk(
  "admin/deleteYoutubeVisuals",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/youtube-visuals/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
const initialState = {};

const YoutubeVisualsSlice = createSlice({
  name: "YoutubeVisualsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllYoutubeVisuals.fulfilled, (state, action) => {
      state.youtubeVisualsData = action.payload.data;
    });
    builder.addCase(getSingleYoutubeVisuals.fulfilled, (state, action) => {
      state.singleYoutubeVisualsData = action.payload.data;
    });
  },
});
export default YoutubeVisualsSlice.reducer;
